import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Capacitor } from '@capacitor/core'
import { useAuth } from '@/hooks/useAuth'
import { useOrpcTanstackQueryUtils } from '../orpc'

// Current user agreement and whether the signed-in user has accepted this version
export function useAgreementStatus() {
  const { isSignedIn } = useAuth()
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.agreement.status.queryOptions(),
    enabled: !!isSignedIn,
  })
}

// Record acceptance of the agreement version the user was shown
export function useAcceptAgreement() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.agreement.accept.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.agreement.key() })
      },
    })
  )
}

export function agreementPlatform(): 'ios' | 'android' | 'desktop' {
  const platform = Capacitor.getPlatform()
  return platform === 'ios' || platform === 'android' ? platform : 'desktop'
}
